export class KibanaDashboardModel {
    id;
    name;
}
//# sourceMappingURL=osd-dashboard.js.map